import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useInitialRender } from '../../../../../play-core/hooks/use-initial-render';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { useLoginState } from '../../../providers/DataProvider/DataContext';
import { PlayAlertLink } from '../../ClickableComponents/PlayLink';
import { jsx as _jsx } from "react/jsx-runtime";
export const LoginButton = () => {
  const {
    t
  } = useTranslation();
  const {
    isLoggedIn
  } = useLoginState();
  const {
    loginSupported
  } = useVideoConfig();
  const isInitialRender = useInitialRender();
  const isVisible = loginSupported && !isLoggedIn && !isInitialRender;
  return /*#__PURE__*/_jsx(Fragment, {
    children: isVisible && /*#__PURE__*/_jsx(PlayAlertLink, {
      size: "small",
      to: `https://www.rts.ch/profile/login?redirect=${window.location.href}`,
      text: t('global.login')
    })
  });
};